import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { JobCategorySubForm} from '../subforms/JobCategory';
import { OtherInformationFormalSubForm ,Schema as OtherInformationSchema} from '../subforms/OtherInformationFormal';
import { RecommendationSubForm, Schema as RecommendationSchema } from '../subforms/Recommendation';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const ZimmerFachkraefteSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(NameAndContactSchema(settings))
        .concat(OtherInformationSchema)
        .concat(RecommendationSchema(settings))
        .concat(PersonalDataSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const ZimmerFachkraefte = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} settings={settings} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={JobCategorySubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationFormalSubForm} colors={colors} settings={settings} />
            <Field component={RecommendationSubForm} colors={colors} settings={settings} />
            <Field component={PersonalDataSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}